import React, { useEffect, useState } from "react";
import useAddJewellery, { jewelleryMediaType } from "./hooks/useAddJewellery";
import DeleteModal from "Common/DeleteModal";
import AddJewelleryForm from "./AddJewelleryForm";
import BreadCrumb from "Common/BreadCrumb";
import AddDiamondModel from "./AddDiamondModel";
import {
  getCategories as onGetCategories,
  getShapes as onGetShapes,
} from "slices/thunk";
import { useDispatch } from "react-redux";

const defaultJewelleryMedia: jewelleryMediaType[] = [
  { id: "", type: "yellowgold", label: "Yellow Gold", files: [], images: [] },
  { id: "", type: "rosegold", label: "Rose Gold", files: [], images: [] },
  { id: "", type: "whitegold", label: "White Gold", files: [], images: [] },
];

const AddJewellery = () => {
  const [jewelleryMedia, setJewelleryMedia] = useState<jewelleryMediaType[]>(
    defaultJewelleryMedia
  );
  const [deletedImagesUrls, setDeletedImagesUrls] = useState<string[]>([]);
  const {

    categories,
    handleJewelleryCategoryOptions,

    shapes,
    handleShapesOptions,
   
  } = useAddJewellery({ jewelleryMedia, setJewelleryMedia, deletedImagesUrls, setDeletedImagesUrls });

  const dispatch = useDispatch<any>();

  useEffect(() => {
    if (categories.length) {
      handleJewelleryCategoryOptions();
    }
  }, [categories]);

  useEffect(() => {
    if (shapes.length) {
      handleShapesOptions();
    }
  }, [shapes]);

  useEffect(() => {
    dispatch(onGetCategories());
    dispatch(onGetShapes());
  }, []);

  return (
    <React.Fragment>
      <BreadCrumb title="Add New" pageTitle="Jewellery" />



      <div className="grid grid-cols-1 xl:grid-cols-12 gap-x-5">
        <div className="xl:col-span-12">
          <div className="card">
            <div className="card-body">
              <h6 className="mb-4 text-15">Create Product</h6>
              <AddJewelleryForm
                jewelleryMedia={jewelleryMedia}
                setJewelleryMedia={setJewelleryMedia}
                deletedImagesUrls={deletedImagesUrls}
                setDeletedImagesUrls={setDeletedImagesUrls}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AddJewellery;
